var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 25,
    cy: 25,
    r: 25,
    fill: "url(#paint0_linear_119_849)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 30C21.152 29.9985 22.2682 29.5998 23.1604 28.8711C24.0526 28.1424 24.6663 27.1284 24.898 26H27V28H29V26H31V29H33V26H34V24H24.898C24.6663 22.8716 24.0526 21.8576 23.1604 21.1289C22.2682 20.4002 21.152 20.0015 20 20C17.243 20 15 22.243 15 25C15 27.757 17.243 30 20 30ZM20 22C21.654 22 23 23.346 23 25C23 26.654 21.654 28 20 28C18.346 28 17 26.654 17 25C17 23.346 18.346 22 20 22Z",
    fill: "url(#paint1_linear_119_849)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_119_849",
    x1: -2.3283e-7,
    y1: 25.0001,
    x2: 50,
    y2: 25.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E75FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C66EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_119_849",
    x1: 15,
    y1: 25,
    x2: 34,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E75FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C66EFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyFrame);
export default __webpack_public_path__ + "static/media/keyFrame.2d149943bd23d04bc465c7861860357f.svg";
export { ForwardRef as ReactComponent };